import { ComponentsOverrides, Theme } from '@mui/material';

export const MuiIconButton: { styleOverrides: ComponentsOverrides<Theme>['MuiIconButton'] } = {
    styleOverrides: {
        root: ({ ownerState, theme }) => ({
            ...(ownerState.color === 'light' && {
                '&:hover': {
                    backgroundColor: theme.palette.grey['900'],
                },
            }),
        }),
        sizeMedium: {
            minWidth: 40,
            minHeight: 40,
        },
    },
};

// Custom color needs additional override to be accepted
declare module '@mui/material/IconButton' {
    interface IconButtonPropsColorOverrides {
        light: true;
        dark: true;
        medium: true;
    }
}
